import { typeof as _typeof } from '../../_virtual/_rollupPluginBabelHelpers.js';

/* eslint-disable unicorn/filename-case */

/**
 * Taken directly from the lodash v4.17.4 node package.
 * src files copied here to avoid relying on the whole dependency.
 * Source Here: https://github.com/lodash/lodash/blob/master/.internal/freeGlobal.js
 *
 * Detect free variable `global` from Node.js.
 */
var freeGlobal = (typeof global === "undefined" ? "undefined" : _typeof(global)) === 'object' && global !== null && global.Object === Object && global;

export default freeGlobal;
